// extracted by mini-css-extract-plugin
module.exports = {"downloadLink":"NWkPrImm","link":"Xs1922id"};